const tooltipOptions = {
    placement: "top",
};

window.addEventListener("load", () => {
    globalThis.ret.initContentTooltips(".js-cell-tooltip-init", tooltipOptions);
});
